import { PropsWithChildren, ReactNode } from "react";
import styles from "./Description.module.css";

type DescriptionList = PropsWithChildren;

export const DescriptionList = ({ children }: DescriptionList) => {
  return <dl>{children}</dl>;
};

interface DescriptionProps {
  label: string;
  value: ReactNode;
}
const Description = ({ label, value }: DescriptionProps) => {
  return (
    <div className={styles.description}>
      <dt className={styles.label}>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
};

export default Description;
